import { Component } from "vue";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";
import { AdvancedAnalysisHelpContentType, } from "../models/AdvancedAnalysisHelpContentType";


export class AdvancedAnalysisHelpContentFactory extends HelpContentFactory<AdvancedAnalysisHelpContentType> {

    public cdnContentPath: string = "advanced_analysis";

    public async tryGetStaticHelpContentByType(type: AdvancedAnalysisHelpContentType | string): Promise<Component | null> {
        switch (type) {
            case AdvancedAnalysisHelpContentType.Default:
            default:
                return null;
        }
    }

}
